import React from "react";

import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

const Spinner = () => {
  const antIcon = <LoadingOutlined className="fs-24" spin />;

  return <Spin indicator={antIcon} className="loading" center="true" />;
};

export default Spinner;
